<script lang="ts" module>
  export interface PartDetail {
    name: string;
    code?: string;
    dims: string;
    materialName?: string;
    materialColor?: string;
    /** salonType (0 = cố định) — dịch nhãn lúc render theo locale. */
    motion: number;
  }
</script>

<script lang="ts">
  import { t } from '../i18n/index.svelte';
  let { info }: { info: PartDetail } = $props();
</script>

<div class="info">
  <div class="head">{t('info.selecting')}: <strong>{info.name}</strong></div>
  <dl>
    {#if info.code}
      <dt>{t('info.code')}</dt>
      <dd>{info.code}</dd>
    {/if}
    <dt>{t('info.dims')}</dt>
    <dd>{info.dims}</dd>
    {#if info.materialName}
      <dt>{t('info.material')}</dt>
      <dd class="mat">
        {#if info.materialColor}
          <span class="swatch" style="background:{info.materialColor}"></span>
        {/if}
        {info.materialName}
      </dd>
    {/if}
    <dt>{t('info.motion')}</dt>
    <dd>{t(`motion.${info.motion}`)}</dd>
  </dl>
</div>

<style>
  .info {
    border-top: 1px solid var(--color-border);
    padding-top: var(--space-sm);
  }
  .head {
    font-size: var(--font-size-caption);
    color: var(--color-text-secondary);
    margin-bottom: var(--space-xs);
  }
  .head strong {
    color: var(--color-text-primary);
    font-size: var(--font-size-body);
  }
  dl {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 4px var(--space-md);
    margin: 0;
  }
  dt {
    color: var(--color-text-secondary);
    font-size: var(--font-size-caption);
  }
  dd {
    margin: 0;
    font-weight: 600;
    font-size: var(--font-size-caption);
  }
  .mat {
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .swatch {
    width: 12px;
    height: 12px;
    border-radius: 3px;
    border: 1px solid var(--color-border);
  }
</style>
